<mat-toolbar class="page-header">
    <div class="menu-container">
      <div class="pg-title">Policies - CelcomDigi</div>
  
      <div class="filter-container">
        <mat-form-field appearance="outline" class="pg-filter" floatLabel="never">
          <input
            (ngModelChange)="searchText = $event; searchChange.next()"
            [ngModel]="searchText"
            autocomplete="off"
            matInput
            placeholder="Search here..."
          />
          <button
            (click)="resetTextFilter()"
            *ngIf="searchText"
            class="clear-field-btn"
            mat-icon-button
            matSuffix
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field appearance="outline" class="pg-filter" floatLabel="never">
          <mat-select
            (ngModelChange)="selectedPolicyStatusList = $event; filter()"
            [ngModel]="selectedPolicyStatusList"
            multiple
          >
            <mat-select-trigger>
              {{ getPolicyStatusDisplay() }}
            </mat-select-trigger>
            <mat-option>
              <ngx-mat-select-search
                (ngModelChange)="filterPolicyStatusSelection($event)"
                (toggleAll)="toggleSelectAllPolicyStatus($event)"
                [ngModelOptions]="{ standalone: true }"
                [searching]="!policyStatusList.length"
                [showToggleAllCheckbox]="true"
                [toggleAllCheckboxChecked]="isSelectedAllPolicyStatus()"
                [toggleAllCheckboxIndeterminate]="isIndeterminatePolicyStatus()"
                ngDefaultControl
                ngModel
                noEntriesFoundLabel="No matching insurer found"
                placeholderLabel="Search policy status..."
              >
              </ngx-mat-select-search>
            </mat-option>
            <mat-option
              *ngFor="let item of filterPolicyStatusList"
              [value]="item.id"
            >
              {{ item.name }}
            </mat-option>
          </mat-select>
          <button
            (click)="resetPolicyStatus()"
            *ngIf="!isSelectedAllPolicyStatus()"
            class="clear-field-btn"
            mat-icon-button
            matSuffix
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field appearance="outline" class="pg-filter" floatLabel="never">
          <mat-select
            (ngModelChange)="selectedClaimStatusList = $event; filter()"
            [ngModel]="selectedClaimStatusList"
            multiple
            placeholder="Claim status filter"
          >
            <mat-select-trigger>
              {{ getClaimStatusDisplay() }}
            </mat-select-trigger>
            <mat-option>
              <ngx-mat-select-search
                (ngModelChange)="filterClaimStatusSelection($event)"
                (toggleAll)="toggleSelectAllClaimStatus($event)"
                [ngModelOptions]="{ standalone: true }"
                [searching]="!claimStatusList.length"
                [showToggleAllCheckbox]="true"
                [toggleAllCheckboxChecked]="isSelectedAllClaimStatus()"
                [toggleAllCheckboxIndeterminate]="isIndeterminateClaimStatus()"
                ngDefaultControl
                ngModel
                noEntriesFoundLabel="No matching status found"
                placeholderLabel="Search Claim Status..."
              >
              </ngx-mat-select-search>
            </mat-option>
            <mat-option
              *ngFor="let item of filterClaimStatusList"
              [value]="item.id"
            >
              {{ item.name }}
            </mat-option>
          </mat-select>
          <button
            (click)="resetClaimStatus()"
            *ngIf="isSelectedAllClaimStatus()"
            class="clear-field-btn"
            mat-icon-button
            matSuffix
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
  
        <mat-form-field
          (click)="lastFilterSelected = filterSelected"
          appearance="outline"
          class="pg-filter"
          floatLabel="never"
        >
          <mat-select [(ngModel)]="filterSelected">
            <mat-select-trigger>
              <ng-container [ngSwitch]="filterSelected">
                <span *ngSwitchCase="'today'">Today</span>
                <span *ngSwitchCase="'week'">This Week</span>
                <span *ngSwitchCase="'month'">This Month</span>
                <span *ngSwitchCase="'year'">This Year</span>
                <span *ngSwitchCase="'all'">All Time</span>
                <span *ngSwitchDefault>
                  <span *ngIf="endDate">
                    {{ startDate | date : "dd/MM/yy" }}
                    - {{ endDate | date : "dd/MM/yy" }}
                  </span>
                </span>
              </ng-container>
            </mat-select-trigger>
            <mat-option (click)="resetDate()" value="all">All Time</mat-option>
            <mat-option (click)="setCurrentYearDate()" value="year"
              >This Year
            </mat-option>
            <mat-option (click)="setCurrentMonthDate()" value="month"
              >This Month
            </mat-option>
            <mat-option (click)="setCurrentWeekDate()" value="week"
              >This Week
            </mat-option>
            <mat-option (click)="setTodayDate()" value="today">Today</mat-option>
            <mat-option (click)="picker.open()" value="custom"
              >Custom Range
            </mat-option>
            <!-- NEW DATE PICKER UI  -->
            <mat-date-range-input [rangePicker]="picker" style="display: none">
              <input
                (dateChange)="onStartDateSelected($event)"
                [(ngModel)]="startDate"
                matStartDate
                placeholder="Start date"
              />
              <input
                (dateChange)="onEndDateSelected($event)"
                [(ngModel)]="endDate"
                matEndDate
                placeholder="End date"
              />
            </mat-date-range-input>
            <mat-date-range-picker
              #picker
              (closed)="onDateRangePickerClosed()"
              (opened)="startDateOpen()"
            >
            </mat-date-range-picker>
          </mat-select>
          <button
            (click)="resetDateFilter()"
            *ngIf="filterSelected !== 'all'"
            class="clear-field-btn"
            mat-icon-button
            matSuffix
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>
  </mat-toolbar>
  
  <div class="content-container">
    <div class="pb-sm" fxLayoutAlign="space-between">
      <div></div>
      <!--<div>
        <button
          (click)="exportPolicies()"
          [functionCode]="'f_damageprotection_maxis_exportdata'"
          appCheckFunctionPermission
          color="primary"
          mat-stroked-button
        >
          Export data
        </button>
      </div>-->
    </div>
    <mat-card class="card-table">
      <table
        (matSortChange)="sortChange($event)"
        [dataSource]="dataSource"
        class="celcomdigi-policies-table"
        mat-table
        matSort
        matSortActive="createdDate"
        matSortDirection="desc"
        matSortDisableClear
      >
        <ng-container matColumnDef="createdDate">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Date Created</th>
          <td
            *matCellDef="let element; dataSource: dataSource"
            [copyValue]="element.createdDate | date : 'dd MMM yyyy / hh:mm aa'"
            class="sm-col"
            mat-cell
          >
            {{ (element.createdDate | date : "dd MMM yyyy / hh:mm aa") || "-" }}
          </td>
        </ng-container>
  
        <ng-container matColumnDef="productType">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Product Type</th>
          <td
            *matCellDef="let element; dataSource: dataSource"
            [copyValue]="element.UI_productType || ''"
            class="sm-col"
            mat-cell
          >
            {{ element.UI_productType || "-" }}
          </td>
        </ng-container>
  
        <ng-container matColumnDef="policyRefNo">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Policy Ref No.</th>
          <td
            *matCellDef="let element; dataSource: dataSource"
            [copyValue]="element.policyRefNo || ''"
            class="sm-col"
            mat-cell
          >
            {{ element.policyRefNo || "-" }}
          </td>
        </ng-container>
  
        <ng-container matColumnDef="mobileNo">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Mobile No.</th>
          <td
            *matCellDef="let element; dataSource: dataSource"
            [copyValue]="element.mobileNo || ''"
            class="sm-col"
            mat-cell
          >
            {{ element.mobileNo || "-" }}
          </td>
        </ng-container>
  
        <ng-container matColumnDef="status">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Policy Status</th>
          <td *matCellDef="let element; dataSource: dataSource" mat-cell>
            <span
              *ngIf="element.UI_status"
              class="cover-label"
              [ngClass]="getPolicyStatusCss(element.UI_status)">
              {{ element.UI_status }}
            </span>
          </td>
        </ng-container>
  
        <ng-container matColumnDef="claimStatus">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Claim Status</th>
          <td *matCellDef="let element; dataSource: dataSource" mat-cell>
            <span
              *ngIf="element.UI_claimStatus"
              class="cover-label"
              [ngClass]="getClaimStatusCss(element.UI_claimStatus)">
              {{ element.UI_claimStatus }}
            </span>
          </td>
        </ng-container>
  
        <ng-container matColumnDef="action">
          <th *matHeaderCellDef mat-header-cell></th>
          <td *matCellDef="let element; dataSource: dataSource" mat-cell>
            <button
              (click)="selected = element"
              [matMenuTriggerFor]="menu"
              mat-icon-button
            >
              <mat-icon>more_vert</mat-icon>
            </button>
          </td>
        </ng-container>
  
        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
  
        <tr *matNoDataRow>
          <td class="mat-cell" colspan="9999">
            <div
              *ngIf="!isLoading && dataSource.length === 0"
              class="mv-lg"
              fxLayout="column"
              fxLayoutAlign="center center"
            >
              <img alt="" src="https://i.ibb.co/RhqwZRK/no-record-found.png" />
              <div class="fs-lg color-muted">No policies found</div>
            </div>
            <ngx-skeleton-loader
              *ngIf="isLoading"
              [theme]="{
                height: '40px',
                'animation-duration': '1s'
              }"
              count="3"
            >
            </ngx-skeleton-loader>
          </td>
        </tr>
      </table>
  
      <mat-divider></mat-divider>
  
      <mat-paginator
        #paginator
        (page)="pageChange($event)"
        [length]="length"
        [pageSizeOptions]="[50, 100, 150]"
        [pageSize]="limit"
        aria-label="Select page of users"
      ></mat-paginator>
    </mat-card>
  </div>
  <mat-menu #menu="matMenu">
    <button (click)="viewClaims(selected?.policyId)" mat-menu-item>View</button>
    <div
    [functionCode]="'f_personalprotection_celcomdigi_cancelpolicy'"
    appCheckFunctionPermission
  >
    <button
      (click)="deactivate(selected)"
      *ngIf="
        selected?.status === 'Active' &&
        selected?.productType === 'TP' &&
        selected?.claimStatus === null
      "
      [functionCode]="'f_personalprotection_celcomdigi_cancelpolicy'"
      appCheckFunctionPermission
      class="color-red"
      mat-menu-item
    >
      Cancel policy
    </button>
  </div>
  </mat-menu>
  